import { render, staticRenderFns } from "./ViewImageReleases.vue?vue&type=template&id=f786dca2&scoped=true&"
import script from "./ViewImageReleases.vue?vue&type=script&lang=js&"
export * from "./ViewImageReleases.vue?vue&type=script&lang=js&"
import style0 from "./ViewImageReleases.vue?vue&type=style&index=0&id=f786dca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f786dca2",
  null
  
)

export default component.exports